import axios from 'axios'
import jwt from 'jsonwebtoken'
import _ from 'lodash'
import url from 'url'
import accountTypeConfig from '../config/accountTypeConfig'
import SecurityService from '../js/util/SecurityService.js'
// import store from '../store'
import store from '../store/index'
import { getImages } from './bankImagesIndex.js'

async function formatImage (bankList) {
  const files = getImages()
  bankList.map(item => {
    const index = _.findIndex(files.fileList, function (o) {
      return o.name === item.bankKey
    })
    if (index !== -1) {
      item.icon = files.fileList[index].fileContext
    } else {
      const otherBank = require('../assets/images/banklogo/OTHER.png')
      item.icon = otherBank
    }
  })
  return bankList
}
export default {
  getCurrentPageData: function (currentPage, pageSize, totalData) {
    var startSeq = (currentPage - 1) * pageSize
    var endSeq = currentPage * pageSize
    if (endSeq > totalData.length) {
      endSeq = totalData.length
    }
    return totalData.slice(startSeq, endSeq)
  },
  getCookie: function (cname) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1)
      if (c.indexOf(name) !== -1) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  },
  setCookie: function (cname, cvalue, exdays) {
    var d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    var expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + ';' + expires
  },
  formatCurrency: function (num) {
    if (!num) {
      return '0.00'
    }
    num = num.toString().replace(/\$|\,/g, '')
    if (isNaN(num)) {
      num = '0.00'
    }
    var sign = (num == (num = Math.abs(num)))
    num = Math.floor(num * 100 + 0.50000000001)
    var cents = num % 100
    num = Math.floor(num / 100).toString()
    if (cents < 10) {
      cents = '0' + cents
    }
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
      num = num.substring(0, num.length - (4 * i + 3)) + ',' +
      num.substring(num.length - (4 * i + 3))
    }
    return (((sign) ? '' : '-') + num + '.' + cents)
  },
  getHttpQuery: function () { // 从url获取传参
    let json = {}
    const urlParse = url.parse(window.location.href)
    let str = urlParse.query ? urlParse.query : urlParse.hash
    if (str && str.includes('?')) {
      str = str.split('?')[1]
    }
    str && str.split('&').forEach(item => {
      let split = item.split('=')
      json[split[0]] = split[1]
    })
    return json
  },
  getUserInfo: async function () {
    let securityService = new SecurityService()
    let userInfo = await securityService.getToken()
    return userInfo
  },
  getToken: function () {
    const idToken = localStorage.getItem('id_token')
    const accessToken = localStorage.getItem('access_token')
    let token = {
      idToken,
      accessToken
    }
    return token
  },
  getProfile: function () {
    let userInfo = this.getToken()
    let profile = null
    if (userInfo) {
      const idToken = userInfo.idToken
      const decoded = jwt.decode(
        idToken, {
          complete: true
        })
      profile = decoded ? decoded.payload : null
    }
    store.commit('setUser', { profile: profile })
    return profile
  },
  getParamByKey: function (key) {
    let objStr = localStorage.getItem(key)
    let obj = JSON.parse(objStr)
    return obj
  },
  formatResponse: function (res) {
    if (res.code === 200) {
      if (res.data.rows) {
        return res.data.rows
      } else {
        return res.data
      }
    } else {
      console.log('>>>>>>>>>>>>>>')
    }
  },
  tradeAccountTypeMaps (tradeAccountType) {
    let maps = {
      securitiesCash: 'stock',
      securitiesMargin: 'stock',
      securitiesAyersCash: 'stock',
      futuresMargin: 'futures',
      futuresDayTradingMargin: 'futures',
      futuresDaytradingMargin: 'futures',
      interactiveBrokerIntegratedMargin: 'ib',
      bullionMargin: 'pm',
      mt5: 'mt5',
      mf: 'mf'
    }
    let key = maps[tradeAccountType]
    return key
  },
  formatBalanceRes: function (res, tradeAccountType) {
    let newRes = {
      total_balance: 0,
      base_currency: '',
      tradeAccount: '',
      cashList: [],
      accountType: '',
      tradeAccountType: tradeAccountType
    }
    // 组装data
    let key = this.tradeAccountTypeMaps(tradeAccountType)
    let tradeAccountConfig = this.getTradeAccountConfig(tradeAccountType)
    if (res) {
      switch (key) {
        case 'stock':
          const currencyObj = {
            '0': 'CNY',
            '1': 'USD',
            '2': 'HKD'
          }
          newRes.total_balance = res.total_cash
          newRes['equity'] = res.ref_portfolio
          newRes.tradeAccount = res.fund_account
          newRes.accountType = res.acc_type
          newRes.base_currency = tradeAccountConfig['currency']['value']
          if (Object.prototype.toString.call(res.cash_list) === '[object Array]') {
            res.cash_list.map(item => {
              let newItem = {}
              newItem['rate'] = item.rate
              newItem['currency'] = currencyObj[item.ccy]
              newItem['viewBalance'] = item[process.env.VUE_APP_AYERS_BALANCE_FIELD]
              newRes.cashList.push(newItem)
            })
          } else {
            let newItem = {}
            let item = res.cash_list || []
            newItem['rate'] = item.rate || 1
            newItem['currency'] = item.ccy || ''
            newItem['viewBalance'] = item[process.env.VUE_APP_AYERS_BALANCE_FIELD] || 0
            newRes.cashList.push(newItem)
          }
          break
        case 'futures':
          let count = 0
          newRes.base_currency = tradeAccountConfig['currency']['value']
          res.map(item => {
            count += item.TradeRate * item[process.env.VUE_APP_ESUNNY_BALANCE_FIELD]
          })
          newRes.total_balance = count
          newRes.type = key
          if (res.length > 0) {
            newRes.tradeAccount = res[0].AccountNo.toString()
            res.map(item => {
              let newItem = {}
              newItem['rate'] = item.TradeRate
              newItem['currency'] = item.CurrencyNo
              newItem['viewBalance'] = item[process.env.VUE_APP_ESUNNY_BALANCE_FIELD]
              newRes.cashList.push(newItem)
            })
          }
          break
        case 'mf':
          newRes['base_currency'] = tradeAccountConfig['currency']['value']
          newRes.tradeAccount = res.tradeAccount.toString()
          let balance = res['ax21:balance'] || res['ax23:balance']
          newRes.total_balance = Number(balance)// 余额
          newRes['equity'] = res['ax21:equity'] || res['ax23:equity']// 净值
          newRes.marginBalance = res['ax21:usableMargin'] || res['ax23:usableMargin'] // 可用预付款
          newRes.type = key
          break
        case 'mt5':
          newRes['base_currency'] = tradeAccountConfig['currency']['value']
          newRes.total_balance = res[0].Balance // 余额
          newRes['equity'] = res[0].Equity // 净值
          newRes.tradeAccount = res[0].Login.toString()
          newRes.marginBalance = res[0].MarginFree // 可用预付款
          newRes.type = key
          break
        case 'pm':
          newRes['base_currency'] = tradeAccountConfig['currency']['value']
          newRes.total_balance = res[0].balance // 余额
          newRes['equity'] = res[0].equity // 净值
          newRes.tradeAccount = res[0].login.toString()
          newRes.marginBalance = res[0].freeMargin // 可用预付款
          newRes.type = key
          break
      }
    }
    console.log(`>>>>>>>>>${tradeAccountType}`, newRes)
    return newRes
  },
  initData: async function (idToken) {
    const decoded = jwt.decode(
      idToken, {
        complete: true
      })
    let profile = decoded.payload
    let sub = profile.sub
    let accountNumber = profile.custom.accountNumber
    await store.dispatch('getUserInfoByidpUserId', {
      idpUserId: sub,
      accountNumber
    })
    // await store.dispatch('getAcountType', {
    //   accountNumber: accountNumber
    // })
  },
  formatImage,
  async getUploadFileType () {
    // let url = 'https://www.eddid.com.hk/upload-type'
    let url = process.env.VUE_APP_GET_UPLOAD_FILE_TYPE + 'upload-type'
    let res = await axios.get(url)
      .then(result => {
        return result
      }).catch(err => {
        return err
      })
    return res
  },
  async uploadFileAliSDK (file, fileType = 'jpg') {
    // const fileStart = file.slice(0, Math.floor(file.length / 2));
    // const fileEnd = file.slice(Math.floor(file.length / 2), file.length);
    // const newFile = fileEnd + fileStart;
    console.log('open ali sdk')
    try {
      const imgs = ['jpg', 'jpeg', 'png', 'gif']
      const vids = ['mp4', 'mov']
      const pdfs = ['pdf']
      let folder
      if (imgs.includes(fileType)) {
        folder = 'app/image' // 文件夹名
      } else if (vids.includes(fileType)) {
        folder = 'app/video' // 文件夹名
      } else if (pdfs.includes(fileType)) {
        folder = 'app/pdf' // 文件夹名
      }
      console.log(folder)
      const data = {
        filename: `test.${fileType}`, // 文件名
        folder, // 文件夹名
        base64: file
        // base64: `${newFile}`,
      }
      // console.log(data)
      // console.log(data.base64)
      const headers = { 'X-API-KEY': process.env.VUE_APP_ALI_X_API_KEY }
      const res = await axios({
        method: 'POST',
        headers: headers,
        // url: 'https://doc-upload-uat.eddid.com.hk:6888/api/v1/uploads/base64',
        url: process.env.VUE_APP_ALI_UPLOAD_URL + '/uploads/base64',
        data
      }).then(result => {
        return result
      }).catch(err => {
        throw err
      })
      // console.log(res)
      return res.data.data.name
    } catch (err) {
      throw err
    }
  },
  blobToDataURL (blob, callback) {
    let a = new FileReader()
    // a.onload = function (e) { callback(e.target.result) }
    a.onload = function (e) { callback(e.target.result.split(';base64,')[1]) }
    a.readAsDataURL(blob)
  },
  getTradeAccountConfig (tradeAccountType) {
    if (!tradeAccountType) {
      return accountTypeConfig.tradeAccountConfig['default']
    }
    return accountTypeConfig.tradeAccountConfig[tradeAccountType]
  },
  // 自动化测试用
  uploadPicBinder (vueThis, uploadCompents) {
    return function (compId, imgUrl) {
      uploadCompents[compId].autoTestUploadByUrl(imgUrl)
    }
  },
  fmoney (s, n) {
    n = n > 0 && n <= 20 ? n : 2
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    let l = s.split('.')[0].split('').reverse()
    let r = s.split('.')[1]
    let t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
    }
    return t.split('').reverse().join('') + '.' + r
  },
  rmoney (s) {
    return parseFloat(s.replace(/[^\d\.-]/g, ''))
  },
  getUrlKey (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

}
export function changeTradetypeToType (tradeType) {
  // let typeMap = new Map(
  //   ['securitiesCash', '证券(现金)', 'STOCK'],
  //   ['securitiesMargin', '证券(保证金)', 'STOCK'],
  //   ['futuresMargin', '期货', 'FUTURES'],
  //   ['bullionMargin', '现货黄金', 'PM'],
  //   ['interactiveBrokerIntegratedMargin', 'EddidPro', 'IB'],
  //   ['securitiesAyersCash', '全权委托(证券)', 'STOCK'],
  //   ['futuresDayTradingMargin', '期货日内交易', 'FUTURES'],
  //   ['mt5', '杠杆式外汇', 'FOREX'],
  //   ['mf', '外汇账户(Eddid FX Pro)', 'FOREX']
  // )
  let objDic = {
    securitiesCash: 'STOCK',
    securitiesMargin: 'STOCK',
    futuresMargin: 'FUTURES',
    bullionMargin: 'PM',
    interactiveBrokerIntegratedMargin: 'IB',
    futuresDaytradingMargin: 'FUTURES',
    securitiesAyersCash: 'STOCK',
    mt5: 'FOREX',
    mf: 'FOREX',
    fundCash: 'FUND'
  }

  let type = objDic[tradeType] ? objDic[tradeType] : ''
  return type
}
export function handleTradeAccountType (type, that) {
  type = type || ''
  let status = false
  let name = that.$t('common.ACCOUNT')

  if (type !== '') {
    status = true
    let temp = type.toLowerCase().replace(/_[a-z]/g, function (m) {
      return m.slice(1).toUpperCase()
    })
    name = that.$t('common.' + temp)
  }
  return { status, name, type }
}
